import { Burger } from '../core'

export default {

  init() {

    self.header_bar = $('.header .header-bar');
    $('.page-section[class*="bg-image"], .page-section[class*="bg-green"], .page-section[class*="bg-dark-green"]').each(function() {
      $(this).addClass('--header-in-white');
      self.header_bar.clone().appendTo($(this));
    })

    $(window).scroll(function() {
      if ($.mlmi.mobile.isMobile && $('body').hasClass('front-page')) {
        checkFixedHeader()
      }
      if ($.mlmi.mobile.isMobile && $('body').hasClass('single-project')) {
        checkSingleProjectHeader()
      }
      if ($.mlmi.mobile.isMobile && $('body').hasClass('--journal')) {
        checkJournalHeader()
      }
      if ($.mlmi.mobile.isMobile && $('body').hasClass('--projects')) {
        checkProjectsHeader()
      }
    });

    $(window).click(function() {
      if ($('body').hasClass('--menu-open')) {
        $('body').removeClass('--menu-open')
      }
    });

    $('.header-bar, .header__navigation').click(function(event){
      event.stopPropagation();
    });

    function checkFixedHeader(){
      var scrollTop = $(window).scrollTop();
      var trigger = $(window).height() - $('.home-header__content').height() - 150
      if (scrollTop >= trigger) {
        $('body').addClass('--regular-header');
      } else {
        $('body').removeClass('--regular-header');
      }
    }

    function checkSingleProjectHeader(){
      var scrollTop = $(window).scrollTop();
      var trigger = $('.project-header').height() - $('.header .header-bar').height();
      $('.header').css('--bg-offset', '-' + scrollTop + 'px');
      if (scrollTop >= trigger) {
        $('body').addClass('--regular-header');
      } else {
        $('body').removeClass('--regular-header');
      }
    }

    function checkJournalHeader(){
      var scrollTop = $(window).scrollTop();
      var trigger = $(window).height() - $('.header .header-bar').height();
      if (scrollTop >= trigger) {
        $('body').addClass('--regular-header');
      } else {
        $('body').removeClass('--regular-header');
      }
    }

    function checkProjectsHeader(){
      var scrollTop = $(window).scrollTop();
      var trigger = $('.projects-header__list').height() - $('.header .header-bar').height();
      if (scrollTop >= trigger) {
        $('body').addClass('--regular-header');
      } else {
        $('body').removeClass('--regular-header');
      }
    }
  }
}
